<div class="row">
  <div class="col-4">
    <nav aria-label="Pagination" class="d-inline-block">
      <ul class="pagination mb-0">
        <li [class.disabled-pagination-item]="disablePageNavigation || currentPageIndex === 0" class="page-item">
          <a (click)="onLoadPreviousPage()" class="page-link">
            <span class="fa-solid fa-chevron-left"></span>
          </a>
        </li>
        <li class="page-item disabled-pagination-item">
          <span [innerText]="currentPageIndex + 1" class="page-link"></span>
        </li>
        <li [class.disabled-pagination-item]="disablePageNavigation || lastPageReached" class="page-item">
          <a (click)="onLoadNextPage()" class="page-link">
            <span class="fa-solid fa-chevron-right"></span>
          </a>
        </li>
      </ul>
    </nav>
  </div>
  <div class="col-4">
    <div class="table-counter">

    </div>
  </div>
  <div class="col-4">
    <div class="pager-wrapper float-right">
      <div [class.disabled-pagination-item]="disablePageNavigation" class="pager-rows form-row d-inline-block mr-1">
        <label class="mr-sm-2" for="rowsPerPage" translate>Entries per page</label>
        <select (change)="onItemsPerPageChange()" [(ngModel)]="itemsPerPage" class="custom-select"
          id="rowsPerPage">
          @for (itemsCount of itemsPerPageOptions; track itemsCount) {
            <option [innerText]="itemsCount"
            [selected]="itemsCount === itemsPerPage" [value]="itemsCount"></option>
          }
        </select>
      </div>
    </div>
  </div>
</div>
